import React from 'react';

import { ReactComponent } from '../../assets/svg/wifi_tethering.svg';


export default () => <ReactComponent />;
